import { isProxiedEnv } from "PFCore/utilities/routes";

const getBackendHost = (): string | null => {
  const apiEndpoint = window.PF.config.api_endpoint;
  if (!apiEndpoint) {
    return null;
  }
  try {
    return new URL(apiEndpoint).host;
  } catch {
    return null;
  }
};

// TODO: [SP-10364] re-introduce ACCOUNT and user_id once the server-side
// dual-source policy is settled. Atlas currently derives both from the token.
export const buildHandshakeUrl = (endpoint: string, token: string): string => {
  const url = new URL(endpoint);
  url.searchParams.set("token", token);
  const backendHost = isProxiedEnv() ? null : getBackendHost();
  if (backendHost) {
    url.searchParams.set("backend_host", backendHost);
  }
  return url.toString();
};
